
import TableList from "@components/templates/tablelist";
import { HttpGetPromotionList, HttpGetPromotionEditStatus, HttpGetPromotionEditSubmit , HttpGetPromotionReport} from "@/service/products/promotion";
import { mapState, mapGetters } from "vuex";
import compImport from '../compimport'
import comIndex from './update'
import {Button, Dropdown, DropdownItem, DropdownMenu, Icon} from "view-design";
export default {
    mixins: [TableList],
    components: {
        comIndex,
        compImport
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                    EQ_status:null,
                    EQ_promotionType:null,
                    IN_id:null,
                }
            },
            listData:{
                sum:0,
                draft:0,
                submit:0,
                processing:0,
                success:0,
                reject:0,
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename:'',
            datetime:'',
            Plugins: {show: true},
            initData:'',
            TreeSearchs:{
                show:true,
                data: [
                    {
                        label: "活动类型",
                        children:[
                            {
                                label: "站内促销活动",
                                key:'EQ_promotionType',
                                value: 7
                            }, {
                                label: "站内Deal(LD BD)",
                                key:'EQ_promotionType',
                                value: 6
                            }, {
                                label: "折扣平台",
                                key:'EQ_promotionType',
                                value: 5
                            }, {
                                label: "联盟商",
                                key: "EQ_promotionType",
                                value: 4
                            }, {

                                label: "红人",
                                key: "EQ_promotionType",
                                value: 3
                            }, {
                                label: "FB群组",
                                key: "EQ_promotionType",
                                value: 2
                            }, {
                                label: "Deal站",
                                key: "EQ_promotionType",
                                value: 1
                            },
                            {
                                label: "全部",
                                key:'EQ_promotionType',
                                value: null
                            }
                        ]
                    }

                ]
            },
        };
    },

    created() {
        this.update();
    },

    methods: {
        ajaxRequest: HttpGetPromotionList,
        interceptResponse(data){
            this.update();
        },
        update(type,parms){
            this.loading=true
            const formdata = { ...this.formData,search:{...this.formData.search}};
            formdata.search.EQ_status = "";
            HttpGetPromotionReport(formdata).then(res=>{
                for(var item in res.data){
                    if(res.data.hasOwnProperty(item)){
                        if(item == '总计'){
                            this.listData.sum = res.data[item]
                        }
                        if(item == '草稿'){
                            this.listData.draft = res.data[item]
                        }
                        if(item == '已提交'){
                            this.listData.submit = res.data[item]
                        }
                        if(item == '处理中'){
                            this.listData.processing = res.data[item]
                        }
                        if(item == '已完成'){
                            this.listData.success = res.data[item]
                        }
                        if(item == '已驳回'){
                            this.listData.reject = res.data[item]
                        }
                    }
                }
                this.loading=false
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },

        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'promotionUpdate',
                        params: { type: "add"},
                        query: { sourceType: this.formData.search.EQ_type}
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'promotionUpdate',
                        params: { type: "edit"},
                        query: { id: params , sourceType: this.formData.search.EQ_type },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: '导入活动',
                        width: 460,
                        showFooter: false,
                        component: "compImport",
                        comptitle: '已存在活动信息',
                        importType:this.formData.search.EQ_type,
                        actionurl: "/api/v2/productPromotion/import",
                        downrul: '/api/v2/productPromotion/excel',
                    }
                    break;
                case "exportById":
                    this.formData.search.IN_id = params;
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/productPromotion/exportByFilter',this.formData,{
                        executor:'request',
                        download:true,
                    }).catch(err=>{
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    });
                    break;
                case 'export':
                    if(this.total>2000){
                        this.$VMessage.error('导出数据不能大于2000');
                    }else{
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/productPromotion/exportByFilter',this.formData,{
                            executor:'request',
                            download:true,
                        }).catch(err=>{
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                        });
                    }
                    break;
                case "submit":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params, status:1},
                        title: "提交操作",
                        ajaxRequest:HttpGetPromotionEditSubmit
                    }
                    break;
                case "processing":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params, status:2},
                        title: "批量处理操作",
                        ajaxRequest:HttpGetPromotionEditStatus
                    }
                    break;
                case "success":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params, status:3},
                        title: "批量成功操作",
                        ajaxRequest:HttpGetPromotionEditStatus
                    }
                    break;
                case "reject":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params, status:4},
                        title: "批量驳回操作",
                        ajaxRequest:HttpGetPromotionEditStatus
                    }
                    break;
                case "delete":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params, status:5},
                        title: "删除操作",
                        ajaxRequest:HttpGetPromotionEditStatus
                    }
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query'
            },{
                label:'编辑',
                show: true,
                params:id,
                operate:'edit'
            },{
                label:'提交',
                show: true,
                params:id,
                operate:'submit'
            },{
                label:'删除',
                show: true,
                params:id,
                operate:'delete'
            }, ]
        },
    },
    computed: {
        ...mapGetters('diction',['getNewProductList','getNewAccountIdList']),

        TabsData(){
            // console.log(this.listData)
            return [
                {
                    label: `全部（${this.listData.sum}）`,
                    key:'EQ_status',
                    val: null
                },
                {
                    label: `草稿（${this.listData.draft}）`,
                    key:'EQ_status',
                    val: 0
                },{
                    label: `已提交（${this.listData.submit}）`,
                    key:'EQ_status',
                    val: 1
                },  {
                    label: `处理中（${this.listData.processing}）`,
                    key:'EQ_status',
                    val: 2
                }, {
                    label: `已完成（${this.listData.success}）`,
                    key: "EQ_status",
                    val: 3
                }, {
                    label: `已驳回（${this.listData.reject}）`,
                    key: "EQ_status",
                    val: 4
                }
            ]
        },
        ToolsData(){
            if(this.formData.search.EQ_promotionType == null && (this.handleAuth('product.promotion.submit') || this.handleAuth('product.promotion.status'))){
                return [
                    {
                        name: "添加",
                        operate: "add",
                        theme: "primary",
                    },
                    {
                        name: "导入",
                        operate: "import",
                        theme: "warning",
                    },
                    {
                        name: "导出",
                        operate: "exportById",
                        theme: "success",
                        batch:true,
                    },
                    {
                        name: "查询条件导出",
                        operate: "export",
                        theme: "primary",
                    },
                    {
                        name: "批量提交",
                        more:true,
                        batch:true,
                        operate: "submit",
                        theme: "primary",
                    },
                    {
                        name: "批量处理",
                        operate: "processing",
                        more: true,
                        batch:true,
                    },
                    {
                        name: "批量完成",
                        operate: "success",
                        more: true,
                        batch:true,
                    },
                    {
                        name: "批量驳回",
                        operate: "reject",
                        more: true,
                        batch:true,
                    },

                ]
            }else {
                return [
                    {
                        name: "添加",
                        operate: "add",
                        theme: "primary",
                    },
                    {
                        name: "导入",
                        operate: "import",
                        theme: "warning",
                    },
                    {
                        name: "查询条件导出",
                        operate: "export",
                        theme: "primary",
                    },
                ]
            }

        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [

                {
                    label: "渠道",
                    tag: 'vSelect',
                    key: 'EQ_accountId',
                    show:true,
                    options:this.getNewAccountIdList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "Seller Sku",
                    tag: 'vInput',
                    key: 'EQ_sellerSku',
                    show:true,
                },

                // 隐藏起来的搜索
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    hidden:!(this.formData.search['all']==null),
                    options: this.getNewProductList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "推广渠道",
                    tag: 'vSelect',
                    key: 'EQ_promotionAccount',
                    options: [
                        {
                            value: '站外deal free',
                            label: '站外deal free'
                        },
                        {
                            value: '站外deal pay',
                            label: '站外deal pay'
                        },
                        {
                            value: '站外Facebook Giveaway',
                            label: '站外Facebook Giveaway'
                        },
                        {
                            value: '站外FB DEAL GROUP',
                            label: '站外FB DEAL GROUP'
                        },
                        {
                            value: '红人营销',
                            label: '红人营销'
                        },
                        {
                            value: 'AMZ AFFILIATE',
                            label: 'AMZ AFFILIATE'
                        },
                        {
                            value: '站外Coupon site',
                            label: '站外Coupon site'
                        },
                        {
                            value: '站内LD',
                            label: '站内LD'
                        },
                        {
                            value: '站内BD',
                            label: '站内BD'
                        },
                        {
                            value: '站内7-Day deal',
                            label: '站内7-Day deal'
                        },
                        {
                            value: '站内webstore',
                            label: '站内webstore'
                        },
                        {
                            value: '站内social promotion',
                            label: '站内social promotion'
                        },
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    },
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: "ERP SKU",
                    tag: 'vInput',
                    key: 'EQ_erpSku',
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: "活动名称",
                    tag: 'vInput',
                    key: 'CN_promotionName',
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: "创建人",
                    tag: 'vInput',
                    key: 'EQ_createdName',
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: "编辑人",
                    tag: 'vInput',
                    key: 'EQ_updatedName',
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: "备注",
                    tag: 'vInput',
                    key: 'CN_remark',
                    hidden:!(this.formData.search['all']==null),
                },
                {
                    label: '活动开始时间',
                    tag: 'vDatepicker',
                    key: 'BT_beginTime',
                    style: "width:180px",
                    hidden:!(this.formData.search['all']==null),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
                {
                    label: '活动结束时间',
                    tag: 'vDatepicker',
                    key: 'BT_endTime',
                    style: "width:180px",
                    hidden:!(this.formData.search['all']==null),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
                {
                    label: '更新时间',
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    style: "width:180px",
                    hidden:!(this.formData.search['all']==null),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                }
            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },{
                    title: '操作',
                    width: 70,
                    render: (h, { row }) => {
                        const id = row.id;
                        if(this.formData.search.EQ_promotionType == null){
                            if(row.status == 0){
                                return <Dropdown placement="bottom-start" trigger="click">
                                    <Button size='small' type='info'>操作 &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                                <DropdownMenu slot="list" class="text-left">
                                    <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'query')}>查看</DropdownItem>
                                    <DropdownItem class='splitline'  nativeOnClick={this.handleOperates.bind(this, id, 'submit')}>提交</DropdownItem>
                                    <DropdownItem class='splitline'  nativeOnClick={this.handleOperates.bind(this, id, 'edit')}>编辑</DropdownItem>
                                    <DropdownItem class='splitline'  nativeOnClick={this.handleOperates.bind(this, id, 'delete')}>删除</DropdownItem>
                                    </DropdownMenu>
                                    </Dropdown >
                            }else if(row.status == 1 || row.status == 2){
                                if(this.handleAuth('product.promotion.status')){
                                    return <Dropdown placement="bottom-start" trigger="click">
                                        <Button size='small' type='info'>操作 &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                                    <DropdownMenu slot="list" class="text-left">
                                        <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'query')}>查看</DropdownItem>
                                        <DropdownItem class='splitline'  nativeOnClick={this.handleOperates.bind(this, id, 'edit')}>编辑</DropdownItem>
                                        </DropdownMenu>
                                        </Dropdown >
                                }else{
                                    return <Button size='small' type='info' nativeOnClick={this.handleOperates.bind(this, id, 'query')}>查看</Button>
                                }
                            }else {
                                return <Button size='small' type='info' nativeOnClick={this.handleOperates.bind(this, id, 'query')}>查看</Button>
                            }
                        }else {
                            return <Button size='small' type='info' nativeOnClick={this.handleOperates.bind(this, id, 'query')}>查看</Button>
                        }
                    }
                },
                {
                    title: '状态',
                    width: 60,
                    render:(h, { row })=>{
                        const status = row.status;
                        const isDelete = row.disabledAt;
                        if(status == 0){
                            return <div>草稿</div>
                        }
                        if(status == 1){
                            return <div>已提交</div>
                        }
                        if(status == 2){
                            return <div>处理中</div>
                        }
                        if(status == 3){
                            return <div>已完成</div>
                        }
                        if(status == 4){
                            return <div>已驳回</div>
                        }
                        if(isDelete != 0){
                            return <div>已失效</div>
                        }
                    }
                },
                {
                    title: '渠道/项目/Seller Sku',
                    render: (h, { row }) => {
                        const accountId = row.accountId;
                        const account = this.getNewAccountIdList.filter((item) => {
                            return accountId == item.value
                        })[0] || {};
                        const lineId = row.lineId;
                        const product = this.getNewProductList.filter((item) => {
                            return lineId == item.value
                        })[0] || {};
                        return <div>
                        <div>{account.label || '--'}</div>
                        <div>{product.label || '--'}</div>
                        <div>{row.sellerSku || '--'}</div>
                        </div>
                    },
                },
                {
                    title: '活动名称/推广渠道',
                    render: (h, { row }) => {
                        return <div>
                        <div><a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.promotionName}</a></div>
                        <div>{row.promotionAccount || '--'}</div>
                        </div>
                    },
                },
                {
                    title: '开始时间/结束时间',
                    width: 80,
                    render: (h, { row }) => {
                        return <div>
                        <div>{row.beginTime || '--'}</div>
                        <div>{row.endTime || '--'}</div>
                        </div>
                    },
                },
                {
                    title: '原价/活动价/折扣形式',
                    width: 80,
                    render: (h, { row }) => {
                        const promotionForm = row.promotionForm
                        var formName = ""
                        if(promotionForm == 1){
                            formName = "直降"
                        }
                        if(promotionForm == 2){
                            formName = "折扣号"
                        }
                        if(promotionForm == 3){
                            formName = "买一赠一"
                        }
                        if(promotionForm == 4){
                            formName = "其他"
                        }
                        if(promotionForm == 5){
                            formName = "Coupon"
                        }
                        return <div>
                        <div>{row.promotionPrice || '--'}</div>
                        <div>{row.promotionFinalPrice || '--'}</div>
                        <div>{formName || '--'}</div>
                        </div>
                    }
                },
                {
                    title: '实际销售额',
                    width: 80,
                    render: (h, { row }) => {
                        return <div>{row.sales || '--'}</div>
                    }
                },
                {
                    title: '推广链接',
                    render: (h, { row }) => {
                        let promotionUrl = row.promotionUrl;
                        if(promotionUrl != "" && promotionUrl != null){
                            promotionUrl = promotionUrl.slice(0, 15) + "..."
                        }

                        return <div>{promotionUrl || '--'}</div>
                    }
                },
                {
                    title: '推广链接流量',
                    width: 90,
                    render: (h, { row }) => {
                        return <div>{row.promotionLinkFlow || '--'}</div>
                    }
                },
                {
                    title: '更新时间',
                    width: 80,
                    render: (h, { row }) => {
                        let updatedAt = row.updatedAt;
                        if(updatedAt != "" && updatedAt != null){
                            updatedAt = updatedAt.slice(0, 10)
                        }
                        return <div>{updatedAt || '--'}</div>
                    }
                },
                {
                    title: '创建人/编辑人',
                    width: 70,
                    render: (h, { row }) => {
                        return <div>
                        <div>{row.createdName || '--'}</div>
                        <div>{row.updatedName || '--'}</div>
                        </div>

                    },
                }
            ];
        },

    },

};
